export enum FormModeEnum {
  CREATE = 1,
  UPDATE = 2,
}
